import { QuotesList } from '../components/QuotesList';
import { useCurrentRequest } from '../hooks/useCurrentRequest';

export const AirlineQuotesScreen = () => {
  const { afrQuotes, request, isLoadingAfrQuotes: isLoading } = useCurrentRequest();

  return <QuotesList request={request} quotes={afrQuotes} isLoading={isLoading} />;
};
